import { TwilioCredentials } from 'app/hooks/fetch/useFetchLiveChat';

let credentials: TwilioCredentials;

export function setCredentials(creds: TwilioCredentials) {
  credentials = creds;
}

const credentialsPromise = new Promise<TwilioCredentials>((resolve) => {
  (function check() {
    if (credentials) {
      return resolve(credentials);
    }
    setTimeout(check, 1000);
  })();
});

export { credentialsPromise };
